import { ContainerForm, MensagemSucesso } from "../styles";

export default function Feedback() {
  return (
    <ContainerForm>
      <MensagemSucesso>
        <p>Informação cadastrada com sucesso!</p>
        <p>A Multicotas entrará em contato assim que tivermos uma compatibilidade. 🙌</p>
      </MensagemSucesso>
    </ContainerForm>
  );
}
